import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import creator from 'utils/action-creator';
import axios from 'utils/axios';
import { errorMessageGenerator } from 'uwork-app-core';

/**
 * Constants
 */
const REQUEST = '@app/orders/activity/get/REQUEST';
const SUCCESS = '@app/orders/activity/get/SUCCESS';
const FAILURE = '@app/orders/activity/get/FAILURE';
const CLEAR = '@app/orders/activity/get/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    logs: [],
    error: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */

// Reducer
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.logs = [];
                draft.error = '';
                draft.loading = true;
                break;
            case SUCCESS:
                draft.loading = false;
                draft.logs = payload;
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.error = '';
                draft.logs = [];
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Saga functions
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.get(`/orders/activity-logs/${payload} `);
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            yield put(actions.failure(errorMessageGenerator(e)));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
